<template>
  <CCol sm="12" class="px-0">
    <CRow>
      <CCol sm="3" class="form-group search-div form-mar-grp mb-0">
        <label for>Utility Charges %</label>
        <input
          type="text"
          class="form-control"
          placeholder="Charges"
          v-model="accountData.utilityCharge.value"
        />
      </CCol>
      <CCol sm="3" class="form-group search-div form-mar-grp mb-0">
        <label for>Cancellation charges %</label>
        <input
          type="text"
          class="form-control"
          placeholder="Charges"
          v-model="accountData.cancellationCharge.value"
          :disabled="accountData.sameAsUtilityCharge"
        />
        <v-checkbox
          :label="'Same as utility charges'"
          hide-details
          class="mt-0 utility-charges-checkbox"
          v-model="accountData.sameAsUtilityCharge"
        ></v-checkbox>
      </CCol>
      <CCol
        sm="3"
        class="form-group search-div form-mar-grp mb-0"
        v-if="tabs === 0 || tabs === 1"
      >
        <label for>Video fees </label>
        <input
          type="text"
          class="form-control"
          placeholder="Charges"
          v-model="accountData.videoFees.amount"
        />
      </CCol>
    </CRow>
    <div class="border-all mt-6 border-radius pt-4 px-4 pb-6" v-if="tabs !== 3">
      <CRow>
        <v-radio-group v-model="accountData.appointmentType">
          <div
            class="d-flex justify-content-space-bet align-items-start radiolabelwidth"
          >
            <v-radio
              v-for="(data, i) in accountData.docsmartCommisions"
              :key="i"
              :label="data.feature"
              color="primary"
              :value="data.feature"
            />
          </div>
        </v-radio-group>
      </CRow>
      <hr />
      <docsmart-commision-tab
        :docsmartCommision="docsmartCommision"
        :index="currentIndex"
        @save="emitCommisionData"
      />
    </div>
    <CCol sm="12" class="flex-end d-flex mt-4">
      <v-btn class="btn btn-primary" @click="updateAccounts">Save</v-btn>
    </CCol>
  </CCol>
</template>
<script>
import Config from "@/config.js";
const API_URL = `${Config.ACCOUNTS_URL}ds-accounts-be`;
export default {
  props: ["accountData", "index", "tabs"],
  components: {
    "docsmart-commision-tab": () =>
      import("@/views/dashboardNew/Accounts/docsmartCommisionTab"),
  },
  data() {
    return {
      docsmartCommision: {},
      currentIndex: this.index ? this.index : 0,
    };
  },
  mounted() {
    if (this.tabs !== 3) {
      for (let i = 0; i < this.accountData.docsmartCommisions.length; i++) {
        if (
          this.accountData.docsmartCommisions[i].feature ==
          this.accountData.appointmentType
        ) {
          this.docsmartCommision = this.accountData.docsmartCommisions[i];
          this.currentIndex = i;
          break;
        }
      }
    }
  },
  watch: {
    "accountData.appointmentType": {
      handler(newValue) {
        for (let i = 0; i < this.accountData.docsmartCommisions.length; i++) {
          if (this.accountData.docsmartCommisions[i].feature == newValue) {
            this.docsmartCommision = this.accountData.docsmartCommisions[i];
            this.currentIndex = i;
            break;
          }
        }
      },
    },
    "accountData.sameAsUtilityCharge": {
      handler(newValue) {
        if (newValue)
          this.accountData.cancellationCharge.value = this.accountData.utilityCharge.value;
      },
    },
  },
  methods: {
    emitCommisionData(data, index) {
      this.accountData.docsmartCommisions[index] = {
        feature: data.feature,
        flat_amount: parseInt(data.flat_amount),
        is_enabled: data.is_enabled,
        percentage: parseInt(data.percentage),
        type: data.type,
      };
    },
    updateAccounts() {
      let obj = {
        cancellation_charges: {
          is_enabled: this.accountData.cancellationCharge.is_enabled,
          type: this.accountData.cancellationCharge.type,
          value: parseInt(this.accountData.cancellationCharge.value),
        },
        utility_charges: {
          is_enabled: this.accountData.utilityCharge.is_enabled,
          type: this.accountData.utilityCharge.type,
          value: parseInt(this.accountData.utilityCharge.value),
        },
        set_cancellation_charges_same_as_utility_charge: this.accountData
          .sameAsUtilityCharge,
        video_fees: {
          is_enabled:
            this.tabs === 0 || this.tabs === 1
              ? this.accountData.videoFees.is_enabled
              : false,
          amount:
            this.tabs === 0 || this.tabs === 1
              ? parseInt(this.accountData.videoFees.amount)
              : 0,
        },
        docsmart_commission: this.accountData.docsmartCommisions ? this.accountData.docsmartCommisions : [],
        role:
          this.tabs === 0
            ? "doctor"
            : this.tabs === 1
            ? "allied"
            : this.tabs === 2
            ? "pharmacy"
            : this.tabs === 3
            ? "docsmart"
            : this.tabs === 4
            ? "diagnostics-lab"
            : this.tabs === 5
            ? "bloodbank"
            : "ambulance",
      };
      let url = `${API_URL}/v2/admin/update-charges-settings`;
      this.$http.post(url, obj).then((response) => {
        if (response.body.status) {
          this.$swal({
            text: response.body.message,
            icon: "success",
            allowOutsideClick: false,
            showCancelButton: false,
            confirmButtonText: "Ok",
          });
        }
      });
    },
  },
};
</script>
<style lang="scss">
.utility-charges-checkbox {
  &.v-input--checkbox {
    .v-input__control {
      .v-input__slot {
        .v-label {
          font-size: 14px;
        }
      }
    }
  }
}
</style>
